"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientStatus = exports.AccountChangeResponseStatus = exports.PatientEmailStatus = exports.GenericMedicamentSubstitutionTypes = exports.ProfileProgressStatus = exports.NextDataToFill = void 0;
var NextDataToFill;
(function (NextDataToFill) {
    NextDataToFill["Healthquestion"] = "healthquestion";
    NextDataToFill["Insurance"] = "insurance";
    NextDataToFill["Address"] = "address";
    NextDataToFill["Personaldata"] = "personaldata";
    NextDataToFill["None"] = "none";
})(NextDataToFill || (exports.NextDataToFill = NextDataToFill = {}));
var ProfileProgressStatus;
(function (ProfileProgressStatus) {
    ProfileProgressStatus["Empty"] = "EMPTY";
    ProfileProgressStatus["Partial"] = "PARTIAL";
    ProfileProgressStatus["Completed"] = "COMPLETED";
})(ProfileProgressStatus || (exports.ProfileProgressStatus = ProfileProgressStatus = {}));
var GenericMedicamentSubstitutionTypes;
(function (GenericMedicamentSubstitutionTypes) {
    GenericMedicamentSubstitutionTypes["Yes"] = "Yes";
    GenericMedicamentSubstitutionTypes["Unknown"] = "Unknown";
    GenericMedicamentSubstitutionTypes["No"] = "No";
    GenericMedicamentSubstitutionTypes["YesOnlyOriginalByGenericMedicament"] = "YesOnlyOriginalByGenericMedicament";
    GenericMedicamentSubstitutionTypes["ZurRoseGenericMedicament"] = "ZurRoseGenericMedicament";
})(GenericMedicamentSubstitutionTypes || (exports.GenericMedicamentSubstitutionTypes = GenericMedicamentSubstitutionTypes = {}));
var PatientEmailStatus;
(function (PatientEmailStatus) {
    PatientEmailStatus[PatientEmailStatus["Error"] = 0] = "Error";
    PatientEmailStatus[PatientEmailStatus["Success"] = 1] = "Success";
    PatientEmailStatus[PatientEmailStatus["TokenExpired"] = 2] = "TokenExpired";
    PatientEmailStatus[PatientEmailStatus["TokenRedeemed"] = 3] = "TokenRedeemed";
    PatientEmailStatus[PatientEmailStatus["TokenMissing"] = 4] = "TokenMissing";
})(PatientEmailStatus || (exports.PatientEmailStatus = PatientEmailStatus = {}));
var AccountChangeResponseStatus;
(function (AccountChangeResponseStatus) {
    AccountChangeResponseStatus[AccountChangeResponseStatus["Error"] = 0] = "Error";
    AccountChangeResponseStatus[AccountChangeResponseStatus["Success"] = 1] = "Success";
    AccountChangeResponseStatus[AccountChangeResponseStatus["TokenExpired"] = 2] = "TokenExpired";
})(AccountChangeResponseStatus || (exports.AccountChangeResponseStatus = AccountChangeResponseStatus = {}));
var PatientStatus;
(function (PatientStatus) {
    PatientStatus[PatientStatus["NotFound"] = 0] = "NotFound";
    PatientStatus[PatientStatus["Found"] = 1] = "Found";
    PatientStatus[PatientStatus["Registered"] = 2] = "Registered";
})(PatientStatus || (exports.PatientStatus = PatientStatus = {}));
//# sourceMappingURL=patient.js.map